/**
 * VSB Verkoop — Vue IIFE voor OpenCart (mount op #vsb-vue-site-footer).
 * Site-eigen entry: pas features/footer/SiteFooter.vue aan zonder Verhuur te wijzigen.
 */
import { createApp } from 'vue';
import SiteFooter from '../features/footer/SiteFooter.vue';

const mountSelector = '#vsb-vue-site-footer';

function bootSiteFooter() {
  const el = document.querySelector(mountSelector);
  if (!el || el.dataset.vsbVueAutostart === '0') {
    return;
  }
  createApp(SiteFooter).mount(el);
  document.documentElement.classList.add('vsb-footer--vue-ready');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSiteFooter);
} else {
  bootSiteFooter();
}
